module.exports = __webpack_public_path__ + "img/icon_read_color.3a01e900.svg";